import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('dashboard', 'change-room-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'put',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'change_room',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/change-room-req.js